<template>
<div id="feedback">

    <div class="text-end">
    <v-text-field clearable label="Search by Customer name, mobile"  prepend-inner-icon="mdi-magnify"
                  outlined @input="onSearch" v-model="search" class="search-field"/>
    </div>

    <v-data-table :headers="headers" :items="feedbacks" :server-items-length="feedbacksCount"
                  :options.sync="options" @update:options="onUpdateOptions" @click:row="rowClick" @update:page="$vuetify.goTo(0)"
                  :footer-props="{itemsPerPageOptions:rowsPerPageItems}" class="feedback-table elevation-0">
        <template v-slot:no-data>No Feedback Available</template>
        <template v-slot:no-results>No Feedback Available</template>
        <template v-slot:item.label="{item}">
                    <v-icon :style="`color:${Constants.CustomerLabel[item.Customer.label]}`" :title="item.Customer.label">mdi-checkbox-blank</v-icon>
        </template>
        <template v-slot:item.name="{ item }">
            <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(([{path: item.Customer.profileImage, type: 'IMAGE'}]))" title="View Image">
                <v-img v-if="item.Customer.profileImage" :src="imgWpx(item.Customer.profileImage, 200)" alt="image" @error="item.Customer.profileImage = null">
                    <template v-slot:placeholder>
                        <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                    </template>
                </v-img>
                <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
            </v-avatar>
            <span class="c-name ellipsis" :title="item.Customer.name">{{ item.Customer.name }}<br>
              <span class="f-12 grey--text text--darken-1">{{item.Customer.mobile}}</span>
            </span>
        </template>
        <template v-slot:item.email="{ item }">
            <span class="c-email ellipsis" :title="item.Customer.email">{{ item.Customer.email || '-' }}</span>
        </template>
        <template v-slot:item.city="{ item }">{{ item.Customer.city || '-' }}</template>
        <template v-slot:item.salesExecutive="{ item }">
            <v-avatar tile :title="(item.Customer.SalesExecutive&&item.Customer.SalesExecutive.name)||'NA'" class="my-3 avatar" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(([{path: item.Customer.SalesExecutive.profileImage, type: 'IMAGE'}]))">
                <v-img v-if="item.Customer.SalesExecutive&&item.Customer.SalesExecutive.profileImage" :src="imgWpx(item.Customer.SalesExecutive.profileImage, 200)" alt="image" @error="item.Customer.SalesExecutive.profileImage = null">
                    <template v-slot:placeholder>
                        <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                    </template>
                </v-img>
                <span v-else-if="item.Customer.SalesExecutive" size="50" color="blue-grey lighten-4">{{acronym_name(item.Customer.SalesExecutive.name)}}</span>
                <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
            </v-avatar>
        </template>
        <template v-slot:item.created_at="{ item }">{{ moment(item.created_at).format('DD MMM YYYY hh:mm A') }}</template>
    </v-data-table>

    <feedback-detail-popup :feedbackDetail="feedbackDetail" :dialog.sync="feedbackDetailDialog"/>
    <gallery id="gallery-feedback-list" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from "moment";
import {SUBSCRIBE_FEEDBACK, SUBSCRIBE_FEEDBACK_COUNT} from "../../graphql/subscriptions/Feedback";
import gallery from '../../mixins/gallery';
import {acronym_name} from "../../util/helpers";
import {debounce} from "lodash";
import FeedbackDetailPopup from "./FeedbackDetailPopup";
import {GET_FEEDBACK_BY_ID} from "../../graphql/queries/Feedback";
let options= {page: 1, itemsPerPage: 25, offset:0, limit:25};

export default {
    name: "Feedback",
    components: {FeedbackDetailPopup},
    mixins: [gallery],
    apollo: {
        $subscribe: {
            feedbackCount:{
                query: SUBSCRIBE_FEEDBACK_COUNT,
                variables () { return { filter: this.filter }},
                result ({ data }) { this.feedbacksCount = data.feedbackCount.aggregate.count },
            },
            Feedback:{
                query: SUBSCRIBE_FEEDBACK,
                variables () { return { filter: this.filter, offset: this.options.offset, limit: this.options.limit}},
                result ({ data }) { this.feedbacks = data.Feedback },
            },
        }
    },
    data () {
        return {
            Constants: Constants,
            user: JSON.parse(localStorage.user),
            moment: moment,
            headers: [
                {text: 'LABEL', value: 'label', width: 84}, {text: 'CUSTOMER', value: 'name', width: 260},
                {text: 'EMAIL', value: 'email', width: 240}, { text: 'CITY', value: 'city' },
                {text: 'SALES EXEC', value: 'salesExecutive'}, {text: 'FEEDBACK ON', value: 'created_at'},
            ],
            feedbacks: [],
            feedbacksCount: 0,
            options: {...options},
            offset: 0, limit: 25, itemsPerPage: 25, rowsPerPageItems: [25, 50, 100, -1],
            search: '',
            filter: '%%',
            acronym_name,
            feedbackDetailDialog: false,
            feedbackDetail: null
        }
    },
    methods:{
        onUpdateOptions(val){
            if(val.itemsPerPage === -1){                                            //'ALL' Rows per page
                this.options.limit = this.feedbacksCount                    //assign total count
                this.options.offset = 0
            }else{
                this.options.limit = val.itemsPerPage
                this.options.offset = (val.page -1) * val.itemsPerPage;
            }
        },
        rowClick(row){
            this.feedbackDetail = row;
            this.feedbackDetailDialog = true
        },
        onSearch: debounce(function(val){
            this.filter = val?('%'+val+'%'):'%%'
            this.options = {...options}             //on search, reset page options
        }, 500),
    },
    async created() {
        if (this.$route.params.id) {
            let response = await this.$apollo.query({
                query: GET_FEEDBACK_BY_ID,
                fetchPolicy: 'network-only',
                variables: {id: this.$route.params.id}
            });
            if (response.data.Feedback.length) this.rowClick(response.data.Feedback[0])
        }
    }
}
</script>

<style scoped>
#feedback{
    padding: 20px;
}
.search-field{
    display: inline-block;
    width: 300px;
}
.feedback-table{
    margin: -16px 0 0 0;
}
.feedback-table:hover{
    cursor: pointer;
}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.c-name {
    display: inline-block;
    vertical-align: middle;
    width: 140px;
    max-width: 140px;
}
.c-email {
    display: inline-block;
    vertical-align: middle;
    width: 200px;
}
</style>